import { render, staticRenderFns } from "./long-title-nofoot.vue?vue&type=template&id=117c0d6f&scoped=true"
import script from "./long-title-nofoot.vue?vue&type=script&lang=js"
export * from "./long-title-nofoot.vue?vue&type=script&lang=js"
import style0 from "./long-title-nofoot.vue?vue&type=style&index=0&id=117c0d6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117c0d6f",
  null
  
)

export default component.exports